import React, { useEffect, useState } from "react";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import PendingIcon from "@mui/icons-material/Pending";
import ErrorIcon from "@mui/icons-material/Error";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning";
import { SCDocumentacionModal } from "../../Dashboard/Clientes/CapturasDashClientes/DocumentadionSC/SCDocumentacionModal";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { SCDocumentacionModalSinVencimiento } from "../../Dashboard/Clientes/CapturasDashClientes/DocumentadionSC/SCDocumentacionModalSinVencimiento";

export const CargarDocumentacionAsesor = ({
  folio,
  setLoader,
  loader,
  idproceso = 31,
}) => {

  const [doctoselect, setDoctoSelect] = useState({
    iddocumento: "",
    documento: "",
  });

  const [data, setData] = useState({
    estado: {},
    documentacion: [],
  });
  const [documentoselect, setDocumentoSelect] = useState({});

  useEffect(() => {
    onObtenerAnalisisDocumentacion();
  }, []);
  const onObtenerAnalisisDocumentacion = () => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`ACDocumentacion/GetAsesor?folio=${folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setData({
          estado: result.estado,
          documentacion: result.documentacion,
        });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  };

  const OnGetIcon = ({ icon }) => {
    switch (icon) {
      case "wait":
        return <PendingIcon className="wait" />;
      case "success":
        return <CheckCircleIcon className="success" />;
      case "warning":
        return <WarningIcon className="warning" />;
      case "error":
        return <ErrorIcon className="error" />;
      default:
        <></>;
    }
  };

  const onImprimirArchivo = (iddocumento) => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `SolicitudCreditoDocumentacion/ObtenerDocumento?folio=${folio}&iddocumento=${Number(
          iddocumento
        )}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = result.comentarios;
        const downloadLink = document.createElement("a");
        const fileName = `${result.documento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  };
  const openModal = (documento, iddocumento) => {
    var modal = document.getElementById("modal-documentos");
    modal.style.display = "block";
    setDocumentoSelect({
      documento,
      iddocumento,
    });
  };

  //Imprime el pedido Generado cuando aun no se a cargado las firmas
  const onImprimirPedidoMaquinaria = (item) => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`PedidoImpresion/ReportePDF?folio=${folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = `data:application/pdf;base64, ${result.documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${result.nombredocumento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  };
  const onImprimirPagare = () => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`Pagares/ImprimirPagare?folio=${folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        if (result.length > 0) {
          result.forEach((documento, index) => {
            const linkSource = `data:application/pdf;base64, ${documento.documento}`;
            const downloadLink = document.createElement("a");
            const fileName = `${documento.nombredocumento}-${index + 1}.${documento.extension}`; // Añade el número de documento al nombre del archivo
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
          });
        } else {
          Swal.fire("Clientes", "No se encontraron documentos para descargar", "info");
        }
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  };

  const onDescargarPedido = () => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`PedidoImpresion/ReportePDF?folio=${folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = `data:application/pdf;base64, ${result.documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${result.nombredocumento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  };

  const onDescargarPagare = () => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`Pagares/ImprimirPagare?folio=${folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        if (result.length > 0) {
          result.forEach((documento, index) => {
            const linkSource = `data:application/pdf;base64, ${documento.documento}`;
            const downloadLink = document.createElement("a");
            const fileName = `${documento.nombredocumento}-${index + 1}.${documento.extension
              }`; // Añade el número de documento al nombre del archivo
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
          });
        } else {
          Swal.fire(
            "Clientes",
            "No se encontraron documentos para descargar",
            "info"
          );
        }
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  };

  return (
    <div className="analisis-solicitud-credito-proceso">
      <SCDocumentacionModalSinVencimiento
        folio={folio}
        documento={documentoselect.documento}
        iddocumento={documentoselect.iddocumento}
        loader={loader}
        setLoader={setLoader}
        setdocumento={setDocumentoSelect}
        setdocumentos={onObtenerAnalisisDocumentacion}
        cargar={true}
      />
      <div
        className={"analisis-credito-modal-mhusa-content-pdf-original"}
        onClick={() => onDescargarPedido()}
      >
        <CloudDownloadIcon />
        <div>Descargar pedido original</div>
      </div>
      <div
        className={"analisis-credito-modal-mhusa-content-pdf-original"}
        onClick={() => onDescargarPagare()}
      >
        <CloudDownloadIcon />
        <div>Descargar pagare original</div>
      </div>
      <div className="analisis-solicitud-credito-proceso-container scroll-4">
        {data.documentacion === undefined ||
          data.documentacion === null ||
          data.documentacion.length === 0 ? (
          <div></div>
        ) : (
          <table cellPadding={0} cellSpacing={0}>
            <thead>
              <tr>
                <th>Documento</th>
                <th>Descargar</th>
                <th colSpan={2}>Cargar</th>
              </tr>
            </thead>
            <tbody>
              {data.documentacion.map((doc) => (
                <tr>
                  <td>{doc.documento}</td>
                  <td>
                    {doc.tiene_documentacion === true ? (
                      <div onClick={() => onImprimirArchivo(doc.iddocumento)}>
                        <CloudDownloadIcon />
                      </div>
                    ) : (
                      doc.iddocumento === 10 ? (
                        <div onClick={() => onImprimirPagare()}>
                          <CloudDownloadIcon />
                        </div>
                      ) : doc.iddocumento === 25 ? (
                        <div onClick={() => onImprimirPedidoMaquinaria()}>
                          <CloudDownloadIcon />
                        </div>
                      ) : (<></>)

                    )}
                  </td>
                  {doc.habilitar === false && doc.icono === "success" ? (
                    <td className="analianalisis-solicitud-credito-procesos-comentarios">
                      <OnGetIcon icon={doc.icono} />
                      {doc.comentarios}
                    </td>
                  ) : (
                    <td className="update-documento-analisis">
                      <div
                        onClick={() =>
                          openModal(doc.documento, doc.iddocumento)
                        }
                      >
                        <CloudUploadIcon />
                        {doc.icono === "wait" ? "Cargar" : "Modificar"}
                      </div>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};
